import { safeLocalStorage } from '@shared/js/safeWebStorage';

const LOCAL_STORAGE_KEY = 'clipLikes';

const clipLikes = {
	namespaced: true,
	state:      () => {
		const storedLikedClips = safeLocalStorage.getJson(LOCAL_STORAGE_KEY, []);
		const likedClips = Array.isArray(storedLikedClips) ? storedLikedClips : [];
		return { likedClips };
	},
	mutations: {
		addLikedClip(state, key) {
			if (!state.likedClips.includes(key)) {
				state.likedClips.push(key);
				safeLocalStorage.setJson(LOCAL_STORAGE_KEY, state.likedClips);
			}
		},
	},
	getters: {
		isLiked: (state) => (eventId, clipId) => {
			const key = `${eventId}_${clipId}`;
			return state.likedClips.includes(key);
		},
	},
	actions: {
		async likeClip({ commit, dispatch }, { eventId, clipId }) {
			const success = await dispatch(
				'tags/likeEventTag',
				{ tagId: clipId, eventId },
				{ root: true }
			);
			if (success) {
				const key = `${eventId}_${clipId}`;
				commit('addLikedClip', key);
			}
			return success;
		},
	},
};

export default clipLikes;
